import { Injectable } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

@Injectable()
export class FiltersService {
  public filtersData = {};
  public searchValue: string;

  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe((params: Params) => {
      this.filtersData = {};

      for (const key in params) {
        if (params.hasOwnProperty(key) && params[key]) {
          this.filtersData[key] = JSON.parse(params[key]);
        }
      }
    });
  }

  public getFilters(): any {
    return this.filtersData;
  }

  public setSearchValue(value: string): void {
    this.searchValue = value;
  }

  public resetSearch(): void {
    this.searchValue = null;
  }

}
